import {URL_ORIGINAL_WEBSITE} from "@/lib/links.ts";

/**
 * Builds a login URL that returns the user to the current page after signing in
 * @param absoluteNext - Send the full URL as `next` instead of just the path
 * @returns Complete login URL with return parameter
 */
export const buildLoginUrlWithReturn = (absoluteNext = false): string => {
  const baseLoginUrl = `${URL_ORIGINAL_WEBSITE}/accounts/login`;

  try {
    const currentUrl = new URL(window.location.href);
    const returnPath = currentUrl.pathname + currentUrl.search + currentUrl.hash;

    if (!returnPath.includes("/accounts/login") && !returnPath.includes("/accounts/logout")) {
      const loginUrl = new URL(baseLoginUrl);
      loginUrl.searchParams.set("next", absoluteNext ? currentUrl.toString() : returnPath);
      return loginUrl.toString();
    }
  } catch (error) {
    console.warn("Failed to parse return URL for login redirect:", error);
  }

  return baseLoginUrl;
};
